import React, { PureComponent, cloneElement } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { contentManagementAction } from "../../../reducers/contentMangementData";
import { AddContent } from "../../MyLibrary";
import {
  handleContentSelect,
  handleDeleteContent,
  handleDeleteContentFromChapter,
  handleAddContent as handleAddContentOnPosition
} from "./helpers/myLibraryFunctions";
import {
  preSelectedFilter,
  setGoalsDriller,
  getContentDataIds,
} from "./helpers/preSelectedFilters";
import { showMsg } from "../../../../course/actions/loaderAlert";
import courseService from "../../../../mylibrary/services/courseService";
import contentManagementService from "../../../service/courseManagementServices";
import { AddBonusDialog } from "../../PopUp";
import { ExpansionalPanel } from "../../ExpansionPanel";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { withStyles } from "@material-ui/core/styles";
import { createStyles, WithStyles } from "@material-ui/core";
import getChapterNumber from "../helper/getChapterNumber";
import { isLastInstanceOfChapter } from "./helpers/isLastInstanceOfChapter";
import courseManagementServices from "../../../service/courseManagementServices";
import { CourseTypes } from "../../../types/enums/CourseTypes";
import { handleAddContent } from "../../coursePlan/courseListing/helpers/handleAllMyLibraryEvents";

const styles = (theme: Theme) =>
  createStyles({
    handleDragIcon: {
      position: "absolute",
      left: 0,
      top: 29,
      zIndex: 9,
    },
    manageDragable: {
      position: "relative",
      paddingLeft: 15,
      "&>:first-child": {
        "&>:first-child": {
          padding: "0!important",
          marginBottom: "0!important",
        },
      },
    },
  });
interface ConceptPhaseProps extends WithStyles<typeof styles> {
  classes: any;
}
interface ConceptPhaseProps {
  conceptPhaseData: any;
  bulkDrag: any;
  treeData: any;
  preFilters: any;
  getPackageByIdData: any;
  filterSelectedQuestion: any;
  showMessage: any;
  setBulkDrag: Function;
  setTreeData: Function;
  setPreFilters: Function;
  setFilterSelectedQuestion: Function;
  subjectTab: any;
  isChapterLevel: boolean;
  levelContent: any[];
  goalsDriller:any;
  mappedConceptsAndChapter: any;
  isPreviewScreen:boolean;
}

interface ConceptPhaseState {
  // hasContent: boolean;
  isOpened: boolean;
  openBonusContent: boolean;
  bonusContent: boolean;
  openMyLibrary: boolean;
  selectedQuestion: any;
  selectedQuestionCount: number;
  preSelectedFilter: any;
  bonusCriteria: any[];
  isDragEnabled: boolean;
  isExpansionPanelOpen: boolean;
  tempQuestions: any;
  preFilters: any;
  selectAllCount: number;
  filterKey:string;
}

const grid = 5;

class ChapterLevelContent extends PureComponent<
  ConceptPhaseProps,
  ConceptPhaseState
> {
  constructor(props: ConceptPhaseProps) {
    super(props);
    this.state = {
      isOpened: true,
      openMyLibrary: false,
      bonusContent: false,
      selectedQuestion: [],
      selectedQuestionCount: 0,
      preSelectedFilter,
      openBonusContent: false,
      bonusCriteria: [],
      isDragEnabled: false,
      isExpansionPanelOpen: false,
      tempQuestions: [],
      preFilters: preSelectedFilter,
      selectAllCount: 0,
      filterKey:'',
    };
  }
  componentDidMount = () => {
    const { preSelectedFilter = {} } = this.state;
    const {
      conceptPhaseData,
      preFilters,
      setPreFilters,
      getPackageByIdData,
      treeData,
    } = this.props;
    const {
      subjectIndex,
      weekIndex,
      phaseIndex,
      chapterIndex,
      conceptIndex,
      key
    } = conceptPhaseData;
    const { content = [], courseSyllabusIds } = conceptPhaseData;
    const { courseDetails = [] } = getPackageByIdData;
    const courseId = _.get(
      courseSyllabusIds,
      `[0].courseId`,
      courseDetails[0].courseId
    );
    let filterKey=`${phaseIndex}-${weekIndex}`;
    if(key=='chapter'){
      filterKey=filterKey+`-${chapterIndex}`;    
    }if(key==='concept'){
      filterKey=filterKey+`-${conceptIndex}`; 
    }
     if((key=='chapter' || key=='concept')&& !preFilters[filterKey]){
        this.setGoalsDriller();
     }
     this.setState({filterKey})
  };

  toggleAddBonusContent = (isChapterLevel?: boolean) => {
    this.setState((prevState) => ({
      openBonusContent: !prevState.openBonusContent,
      isChapterLevel,
    }));
  };

  handleClick = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  // getConceptId = () => {
  //   const { conceptPhaseData, treeData } = this.props;
  //   const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = conceptPhaseData;
  //   const { phases = [] } = treeData;
  //   const conceptId = phases[phaseIndex]
  //   ['weeks']
  //   [weekIndex]['subjects']
  //   [subjectIndex]['chapters']
  //   [chapterIndex]['concepts'][conceptIndex].content.map((ele: any) => ele && ele.id);
  //   return conceptId;
  // }

  getContentType = (type: string) => {
    switch (type) {
      case "studyNotes":
        return "note";
      case "video":
        return "videos";
      case "formula":
        return "formulas";
      case "test":
        return "testpapers";
    }
  };

  handleContentSelectFromLibrary = (content: any, totalCount?: number) => {
    const mainTestTypes = ["full", "part", "combined"];
    const indexToCheck = content.length - 1;
    if (
      content[indexToCheck] &&
      mainTestTypes.includes(content[indexToCheck].contentSubTypeCode)
    ) {
      this.props.showMessage(
        "Main test cannot be added in concept phase",
        "error"
      );
      return;
    }
    const contentLength = totalCount || content.length;
    handleContentSelect(content, contentLength, this.handleSetState);
  };
  handleAddContentFromLibrary = (
    bonusContent: boolean=false,
    bonusCriteria?: any
  ) => {
    const {
      treeData,
      setTreeData,
      conceptPhaseData,
      showMessage,
      isChapterLevel,
      getPackageByIdData,
      mappedConceptsAndChapter
    } = this.props;
    const { selectedQuestion, tempQuestions } = this.state;
    let contents = JSON.parse(JSON.stringify(tempQuestions));
    const {displaySettings}=treeData;
    const {showPhases,showChapters,showConcepts,showWeeks}=displaySettings;
    handleAddContent({ contents, treeData, setTreeData, mappedConceptsAndChapter,level:isChapterLevel?'chapter':'concept',conceptPhaseData,bonusContent, bonusCriteria}, this.handleSelectedFilterQuestion);
    this.handleSetState({
      tempQuestions: [],
      selectedQuestionCount: 0,
    });
  // if((showChapters && isChapterLevel)||(showConcepts && !isChapterLevel)){
  //   const isPanelOpen = handleAddContentOnPosition(
  //     { contents, treeData, setTreeData, conceptPhaseData, bonusContent, bonusCriteria,isChapterLevel},
  //     this.handleSelectedFilterQuestion,
  //     showMessage
  //   );
  //   this.setState({
  //     isExpansionPanelOpen: isPanelOpen,
  //   });
  // }else{
  //  } 
  };

  getItemStyle = (isDragging: any, draggableStyle: any) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? "lightgrey" : "white",

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  enableDrag = () => {
    this.setState({ isDragEnabled: true });
  };
  disableDrag = () => {
    this.setState({ isDragEnabled: false });
  };
  handleOnChangeCheckBox = (event: any, key: string) => {
    event.stopPropagation();
    const { bulkDrag, setBulkDrag, treeData, conceptPhaseData } = this.props;
    let cloneBulkDrag = JSON.parse(JSON.stringify(bulkDrag));
    const {
      name = "",
      subjectIndex,
      chapterIndex,
      phaseIndex,
      weekIndex,
      subjectName,
    } = conceptPhaseData;
    if (!event.target.checked) {
      const newKey = `chapter-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`;
      delete cloneBulkDrag[newKey];
    }
    cloneBulkDrag = {
      ...cloneBulkDrag,
      [key]: event.target.checked,
    };
    setBulkDrag({
      bulkDrag: { ...cloneBulkDrag },
    });
  };
  handleSetState = (updatedStateValues: any) => {
    this.setState((prevState) => ({
      ...prevState,
      ...updatedStateValues,
    }));
  };
  handlePreFiltersData = (key: any, data: any) => {
    const { preFilters, setPreFilters } = this.props;
    setPreFilters({
      preFilters: {
        ...JSON.parse(JSON.stringify(preFilters)),
        [key]: JSON.parse(JSON.stringify(data)),
      },
    });
  };
  handlePreFilterDataWithBulk = (bulkData: any) => {
    const { preFilters, setPreFilters } = this.props;
    setPreFilters({
      preFilters: {
        ...JSON.parse(JSON.stringify(preFilters)),
        ...JSON.parse(JSON.stringify(bulkData)),
      },
    });
  };
  handleSelectedFilterQuestion = (content: any) => {
    const {
      filterSelectedQuestion,
      setFilterSelectedQuestion,
      conceptPhaseData,
      isChapterLevel,
    } = this.props;
    const {
      subjectIndex,
      weekIndex,
      phaseIndex,
      chapterIndex,
      conceptIndex,
    } = conceptPhaseData;
    const phaseKey = `${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${
      isChapterLevel ? conceptIndex + 1 : conceptIndex
    }`;
    let contentData = [...content];
    if (content && content.length) {
      let newFilteredContent = [...filterSelectedQuestion, ...contentData];
      setFilterSelectedQuestion({
        filterSelectedQuestion: [
          ...JSON.parse(JSON.stringify(newFilteredContent)),
        ],
      });
      const excludedIds = contentData.map(
        (ele: any) => ele.content_Id || ele.id
      );
      // let clonePreFilters = this.props.preFilters[phaseKey];
      // clonePreFilters = {
      //   ...clonePreFilters,
      //   excludedIds: [...clonePreFilters.excludedIds, ...excludedIds],
      // };
      // this.handlePreFiltersData(phaseKey, clonePreFilters);
    }
  };
  handleRemoveFilterQuestion = (content: any) => {
    const {
      filterSelectedQuestion,
      setFilterSelectedQuestion,
      preFilters,
      conceptPhaseData,
    } = this.props;
    let newFilteredQuestion = filterSelectedQuestion.filter(
      (element: any) =>
        (element.id && element.id !== content.id) ||
        (element.content_Id && element.content_Id !== content.id)
    );
    setFilterSelectedQuestion({
      filterSelectedQuestion: [
        ...JSON.parse(JSON.stringify(newFilteredQuestion)),
      ],
    });
  };
  toggleOpenMyLibrary = (
    bonusContent?: boolean,
    isChapterLevel: boolean = false
  ) => {
    const propsPreFilters=this.props.preFilters;
    const goalsDriller=this.props.goalsDriller
    const { preFilters,filterKey,preSelectedFilter } = this.state;
    const {displaySettings}=this.props.treeData;
    const {showChapters,showConcepts}=displaySettings;
    let modifyFilter={...preFilters};
    if(Object.keys(propsPreFilters).length>0 && propsPreFilters[filterKey]){  
        modifyFilter = JSON.parse(JSON.stringify(propsPreFilters[filterKey]));
        let subFilters = _.get(
          modifyFilter,
          "contentFilterData[0].filters[1].filters",
          []
        );
          for (let i = 0; i < subFilters.length; i++) {
            if (subFilters[i].filterValue === "chap"||subFilters[i].filterValue === "concept") {
                subFilters[i].filterValue=isChapterLevel ? "chap" : "concept";
                break;
            }
          }
    }
    else if(!_.isEmpty(preSelectedFilter) && (showChapters || showConcepts)){
      modifyFilter = JSON.parse(JSON.stringify(preSelectedFilter));
      modifyFilter.goalsDriller.level=isChapterLevel?'chapter':'concept';
      let subFilters = _.get(
        modifyFilter,
        "contentFilterData[0].filters[1].filters",
        []
      );
        for (let i = 0; i < subFilters.length; i++) {
          if (subFilters[i].filterValue === "chap"||subFilters[i].filterValue === "concept") {
              subFilters[i].filterValue=isChapterLevel ? "chap" : "concept";
              break;
          }
        }
    }
    else{
       modifyFilter.goalsDriller=goalsDriller;
       let contents=["studymaterial","testpapers"];
       let contentTypes=[["videos","formulas","note"],["concept"]];
      contents.forEach((cn:string,i:number)=>{
        const obj:any={
          disabled:false,
          filterValue:cn,
          filters:[],
          isSelected:true
        }
          contentTypes[i].forEach((ct,j)=>{
               obj.filters.push({
                disabled:false,
                filterValue:ct=='concept'?isChapterLevel?'chap':ct:ct,
                filters:[],
                isSelected:true
              })
          })
        modifyFilter.contentFilterData[0].filters.push(obj)
      })    
    }   
    if (!bonusContent) {
      this.setState((prevState) => ({
        openMyLibrary: !prevState.openMyLibrary,
        bonusContent: false,
        preFilters:modifyFilter,
        isChapterLevel
      }));
    } else {
      this.setState((prevState) => ({
        openMyLibrary: !prevState.openMyLibrary,
        bonusContent,
        preFilters:modifyFilter,
        isChapterLevel
      }));
    }
  };
  handleBonusContent = (percentageValue: string) => {
    this.toggleAddBonusContent();
    let bonusCriteria: any = [];
    const { isChapterLevel } = this.props;
    bonusCriteria.push({
      name: "proficiency",
      value: percentageValue,
    });
    this.setState(
      {
        bonusCriteria,
      },
      () => this.toggleOpenMyLibrary(true, isChapterLevel)
    );
    this.handleAddContentFromLibrary(true, bonusCriteria);
  };
  handleContentSelectAll = (selectedQuestion: any, totalCount?: number) => {
    this.handleContentSelectFromLibrary(selectedQuestion, totalCount);
  };
  handleDeleteContent = (contentItem: any) => {
    const { treeData, setTreeData, conceptPhaseData, preFilters } = this.props;
    handleDeleteContent(
      { treeData, setTreeData, contentItem, conceptPhaseData, preFilters },
      this.handlePreFilterDataWithBulk
    );
    this.handleRemoveFilterQuestion(contentItem);
  };
  
  handleDeleteContentFromChapter = (contentItem: any) => {
    const { treeData, setTreeData, conceptPhaseData,isChapterLevel,preFilters } = this.props;
    
    if(isChapterLevel){
    handleDeleteContentFromChapter({
      treeData,
      setTreeData,
      contentItem,
      conceptPhaseData,
    });
    this.handleRemoveFilterQuestion(contentItem);
  }else{
    handleDeleteContent({ treeData, setTreeData, contentItem, conceptPhaseData, preFilters }, this.handlePreFilterDataWithBulk);
  }
}

  handleInitialState = () => {
    this.setState({
      selectedQuestionCount: 0,
      selectedQuestion: [],
    });
  };

  isLastConcept = () => {
    const { conceptPhaseData, treeData } = this.props;
    const { phases } = treeData;
    const currentChapter =
      phases[conceptPhaseData.phaseIndex].weeks[conceptPhaseData.weekIndex]
        .subjects[conceptPhaseData.subjectIndex].chapters[
        conceptPhaseData.chapterIndex
      ];
    return conceptPhaseData.conceptIndex === currentChapter.concepts.length - 1;
  };
  setInitialFilterData = (treeData: any) => {
    let cloneTreeData = JSON.parse(JSON.stringify(treeData));
    const { phases = [] } = cloneTreeData;
    let contentData: any = [];
    phases &&
      phases.length &&
      phases.forEach((phase: any) => {
        const { weeks = [] } = phase;
        weeks &&
          weeks.length &&
          weeks.forEach((week: any) => {
            const { subjects = [] } = week;
            subjects &&
              subjects.length &&
              subjects.forEach((subject: any) => {
                const { chapters = [] } = subject;
                chapters &&
                  chapters.length &&
                  chapters.forEach((chapter: any) => {
                    const { content = [], concepts = [] } = chapter;
                    content &&
                      content.length &&
                      content.forEach((cont: any) => {
                        contentData.push(cont);
                      });
                    concepts &&
                      concepts.length &&
                      concepts.forEach((concept: any) => {
                        const { content = [] } = concept;
                        content &&
                          content.length &&
                          content.forEach((cont: any) => {
                            contentData.push(cont);
                          });
                      });
                  });
              });
          });
      });
    // this.setState({
    //   selectedQuestionCount: contentData.length
    // })
    this.handleSelectedFilterQuestion(contentData);
  };

  //   setTemplates = (courseDetails: any[]) => {
  //     const goals = _.map(courseDetails, 'courseId').join(',');
  //     if (_.isEmpty(goals)) return;
  //     let queryParams: any = {
  //       type : CourseTypes.standard,
  //       goals :goals,
  //       pagination:false };

  //     // queryParams.pageSize = 51;
  //     courseManagementServices.getPackageTemplates(queryParams).then((response: any) => {
  //       const { responseObject = {} } = response;
  //       const packages = _.get(responseObject, 'packages', []);
  //       this.setState({ templates: packages });
  //     });
  //   };

  toggleMyLibraryData = () => {
    this.setState((prevState: any) => ({
      openMyLibrary: !prevState.openMyLibrary,
    }));
  };
  finalSelection = () => {
    const { preFilters } = this.state;
    const { isChapterLevel } = this.props;
    const selectedContentType = isChapterLevel ? "chapter" : "concept";
    const modifyFilter = JSON.parse(JSON.stringify(preFilters));
    if (selectedContentType) {
      let subFilters = _.get(
        modifyFilter,
        "contentFilterData[0].filters[1].filters",
        []
      );
      if (selectedContentType === "chapter" && subFilters.length > 0) {
        let newFilter = [];
        for (let i = 0; i < subFilters.length; i++) {
          if (subFilters[i].filterValue === "chap") {
            newFilter.push(subFilters[i]);
          }
        }
        modifyFilter.contentFilterData[0].filters[1].filters = newFilter;
      } else if (selectedContentType === "concept" && subFilters.length > 0) {
        let newFilter = [];
        for (let i = 0; i < subFilters.length; i++) {
          if (subFilters[i].filterValue === "concept") {
            newFilter.push(subFilters[i]);
          }
        }
        modifyFilter.contentFilterData[0].filters[1].filters = newFilter;
      }
    }
    this.setState((prevState: any) => ({
      openMyLibrary: true,
      preFilters,
      modifyFilter,
    }));
  };

  getAllSelectCount = (count: number) => {
    this.setState({
      selectAllCount: count,
    });
  };
  setGoalsDriller=()=>{
    const { preSelectedFilter = {} } = this.state;
    const { conceptPhaseData, preFilters, setPreFilters, getPackageByIdData, treeData } = this.props;
    const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = conceptPhaseData;
    const { content = [], courseSyllabusIds } = conceptPhaseData;
    const { courseDetails = [] } = getPackageByIdData;
    const courseId = _.get(courseSyllabusIds, `[0].courseId`, courseDetails[0].courseId);
          
       contentManagementService.getCourseDetails(courseId).then((courseData: any) => {
        const { courseType = {} } = courseData;
        courseService.list().then((goalsList: any) => {
          const { subjectId = '', chapterId = '', id } = conceptPhaseData;
          const masterIdOfSubject = subjectId;
          const masterIdOfChapter = chapterId;
          
          setGoalsDriller(
            goalsList,
            courseType,
            this.handleSetState,
            preSelectedFilter,
            conceptPhaseData,
            this.handlePreFiltersData,
            getPackageByIdData,
            treeData,
            masterIdOfSubject,
            masterIdOfChapter,
            id
          );
        });
        // this.setSelectedQuestion();
      });
  }

   render = () => {
    const {
      conceptPhaseData,
      bulkDrag,
      filterSelectedQuestion,
      classes,
      subjectTab,
      treeData,
      isChapterLevel,
      levelContent,
      isPreviewScreen
    } = this.props;
    const {
      openMyLibrary,
      selectedQuestionCount,
      bonusContent,
      openBonusContent,
      bonusCriteria = [],
      preFilters
    } = this.state;
    const {
      name = "",
      subjectIndex,
      conceptIndex,
      chapterIndex,
      weekIndex,
      phaseIndex,
    } = conceptPhaseData;

    const chapter = _.get(
      treeData,
      `phases[${phaseIndex}].weeks[${weekIndex}].subjects[${subjectIndex}].chapters[${chapterIndex}]`,
      []
    );
    const { displaySettings } = treeData;
    const {showPhases,showWeeks,showChapters,showConcepts, showTestVisibility}=displaySettings;
    const selectedContentType = isChapterLevel ? "chapter" : "concept";
    return (
      <span className={classes.manageDragable}>
        {Boolean(Object.keys(preFilters).length) && openMyLibrary && (
          <AddContent
            openMyLibary={openMyLibrary}
            selectedContentType={selectedContentType}
            type="studyMaterial"
            selectedQuestionCount={selectedQuestionCount}
            handleBackToComponent={this.toggleMyLibraryData}
            handleContentSelect={this.handleContentSelectFromLibrary}
            handleInitialState={this.handleInitialState}
            isSelectAllRequired={true}
            preSelectedFilterContent={preFilters}
            handleAddContent={this.handleAddContentFromLibrary}
            isCourse={true}
            handleContentSelectAll={this.handleContentSelectAll}
            getAllSelectCount={this.getAllSelectCount}
            isBonusContent={bonusContent}
            bonusCriteria={bonusCriteria}
            // updateContentTypeValueParent={this.updateContentTypeValue}
            // filterContent={this.props.filterSelectedQuestion}
            // selectedQuestion={this.state.selectedQuestion}
            // onCheckContentExist={this.onCheckContentExist}
            // preSelectedFilterContent={
            //   Boolean(Object.keys(preFilters).length) &&
            //   preFilters[`${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`]
            // }
          />
        )}
        <AddBonusDialog
          isDialogOpen={openBonusContent}
          handleOnClick={this.handleBonusContent}
          handlePopUpClose={this.toggleAddBonusContent}
        />
        <div
          style={{
            borderBottom: "1px solid lightgrey",
            // marginLeft: "-77px",
            marginRight: "-30px",
            // marginTop: "20px",
            paddingLeft: "70px",
            paddingRight: "40px",
            paddingBottom: "30px",
          }}
        >
          {
            <ExpansionalPanel
              name={isChapterLevel?"Chapter Level Content":"Concept Level Content"}
              data={levelContent || []}
              isDeleted={!isPreviewScreen}
              handleDeleteContent={this.handleDeleteContentFromChapter}
              isBulkDataAdded={conceptPhaseData.isBulkAdded}
              isAddContentRequired={!(isPreviewScreen ||(isChapterLevel && showConcepts && !showChapters))}
              isAddBonusContentRequired={!(isPreviewScreen ||(!isChapterLevel && showConcepts && !showChapters))}
              toggleOpenMyLibrary={this.toggleOpenMyLibrary}
              toggleAddBonusContent={this.toggleAddBonusContent}
              // bulkDragDetails={true}
              // bulkDrag={bulkDrag}
              conceptPhaseData={conceptPhaseData}
              isChapterLevel={isChapterLevel}
              showTestVisibility={showTestVisibility}
            />
          }
        </div>
      </span>
    );
  };
}
const mapStateToProps = (state: any) => {
  return {
    treeData: _.get(
      state,
      "courseMangementData.contentManagementData.treeData",
      {}
    ),
    bulkDrag: _.get(
      state,
      "courseMangementData.contentManagementData.bulkDrag",
      {}
    ),
    preFilters: _.get(
      state,
      "courseMangementData.contentManagementData.preFilters",
      {}
    ),
    getPackageByIdData: _.get(
      state,
      "courseMangementData.contentManagementData.packageByIdData.packageData",
      {}
    ),
    filterSelectedQuestion: _.get(
      state,
      "courseMangementData.contentManagementData.filterSelectedQuestion",
      []
    ),
    goalsDriller:_.get(state,"courseMangementData.contentManagementData.goalsDriller",{}),
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setPreFilters: contentManagementAction.setPreFilters,
      setTreeData: contentManagementAction.setTreeData,
      setBulkDrag: contentManagementAction.setBulkDrag,
      setFilterSelectedQuestion:
        contentManagementAction.setFilterSelectedQuestion,
      showMessage: showMsg,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(ChapterLevelContent));
